module.exports = __webpack_public_path__ + "media/images/current_magazine_issue-00e3641df15fd78c0f7d42443a3f2995.jpg";